export const PERSONAL_CODE_LENGTH = 11;
export const REGISTRY_CODE_LENGTH_EE = 8;
export const REGISTRY_CODE_LENGTH_LT = 9;